/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

$(function(){
	$("#page-faq h3.section__title-text").on("click", function() {
		$(this).next().slideToggle();
	});
});


/*-----------------------------------------------------------------------------/
/ STEP 1: /cart/add.js を横取りして _reservation_expiry を自動注入
/ BTAの予約フローはそのまま動く。propertiesに "From" があるリクエストのみ対象。
/-----------------------------------------------------------------------------*/

(function() {
  var EXPIRY_MINUTES = 120;

  // bodyに "From" プロパティがあれば _reservation_expiry を注入する
  // JSON形式・URLエンコード形式
  function injectExpiry(bodyString) {
    if (typeof bodyString !== 'string') return null;

    try {
      var body = JSON.parse(bodyString);
      if (body.properties && body.properties.From) {
        var expiryTimestamp = Math.floor(Date.now() / 1000) + (EXPIRY_MINUTES * 60);
        body.properties['_reservation_expiry'] = String(expiryTimestamp);
        console.log('[reservation-expiry] 期限を注入しました:', new Date(expiryTimestamp * 1000).toLocaleString());
        return JSON.stringify(body);
      }
      return null;
    } catch (e) {}

    if (bodyString.indexOf('properties%5BFrom%5D') !== -1 || bodyString.indexOf('properties[From]') !== -1) {
      var expiryTimestamp = Math.floor(Date.now() / 1000) + (EXPIRY_MINUTES * 60);
      var expiryParam = '&properties%5B_reservation_expiry%5D=' + expiryTimestamp;
      console.log('[reservation-expiry] 期限を注入しました:', new Date(expiryTimestamp * 1000).toLocaleString());
      return bodyString + expiryParam;
    }

    return null;
  }

  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (typeof url === 'string' && url.indexOf('/cart/add.js') !== -1 && options && options.body) {
      var modified = injectExpiry(options.body);
      if (modified) {
        options = Object.assign({}, options, { body: modified });
      }
    }
    return originalFetch.call(this, url, options);
  };

  var originalXHROpen = XMLHttpRequest.prototype.open;
  var originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._cartAddUrl = (typeof url === 'string' && url.indexOf('/cart/add.js') !== -1);
    return originalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    if (this._cartAddUrl && body) {
      var modified = injectExpiry(body);
      if (modified) {
        return originalXHRSend.call(this, modified);
      }
    }
    return originalXHRSend.apply(this, arguments);
  };
})();

/*-----------------------------------------------------------------------------/
/ STEP 2: 予約枠の期限チェック → カート全クリア
/ checkReservationExpiry(callback) — 期限OK時にcallbackを実行、期限切れ時はカート全クリア
/-----------------------------------------------------------------------------*/

function checkReservationExpiry(callback) {
  fetch('/cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      var now = Math.floor(Date.now() / 1000);
      var latestExpiry = 0;

      cart.items.forEach(function(item) {
        var props = item.properties || {};
        var expiry = props['_reservation_expiry'];
        if (expiry) {
          var ts = parseInt(expiry, 10);
          if (ts > latestExpiry) latestExpiry = ts;
        }
      });

      if (latestExpiry === 0 || latestExpiry >= now) {
        if (callback) callback();
        return;
      }

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      }).then(function() {
        alert('カートの有効期限が切れたため、カートを空にしました。再度ご予約ください。');
        window.location.reload();
      });
    })
    .catch(function(err) {
      console.error('カートチェックエラー:', err);
    });
}

// カートページ読み込み時に自動チェック
(function() {
  if (window.location.pathname !== '/cart') return;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { checkReservationExpiry(); });
  } else {
    checkReservationExpiry();
  }
})();

